// extracted by mini-css-extract-plugin
module.exports = {"thumbVertical":"CSliderThumb_thumbVertical__1H5cI"};